import { getAllSlotsHttp, addAgentToRosterHttp, updateAgentRosterHttp, addSlotHttp, updateSlotHttp, getAllagent } from "../../../Http/Index"


export const fetchRoster=async()=>{
    try{
         let response= await getAllSlotsHttp()
         return response?.data
    }catch(err){
        console.log(err)
    }
}

export const addAgent=async(id:string,slotId:string,payload:any)=>{
    try{
      let response=await addAgentToRosterHttp(id,slotId,payload)
      return response.data
    }catch(err){
        console.log(err,"err")
        return err
    }
}

export const updateData=async(id:string,payload:any)=>{
    try{
      let response=await updateAgentRosterHttp(id,payload)
    
      return response.data
    }catch(err){
        return err
    }
}


export const addSlotToRoster=async(payload:any)=>{
    try{
      let response=await addSlotHttp(payload)
    
      return response.data
    }catch(err){
        console.log(err,"err")
        return err
    }

}


export const updateSlot=async(id:string,payload:any)=>{
     try{
      let response=await updateSlotHttp(id,payload)
     
      return response.data
    }catch(err){
        console.log(err,"err")
        return err
    }

}

export const fetchAllAgents=async()=>{
    try{
        let response=await getAllagent()
        return response?.data
    }catch(err){
        console.log(err)
    }
}
